import React from 'react';

import { SiteAnalyticsPageLoader } from '@confluence/confluence-analytics/entry-points/SiteAnalyticsPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { SITE_ANALYTICS } from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { expVal } from '@confluence/feature-experiments';

import { NotFound } from '../NotFound.tsx';

export const SiteAnalyticsRoute: {
	({ params: { tab } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { tab } }: RouteMatch):
		| false
		| {
				Screen: {
					pageState: {
						routeName: string;
						tab: string;
					};
				};
				MainLayout: {
					navView: string;
				};
		  };
} = ({ params: { tab } }: RouteMatch): React.JSX.Element => {
	if (tab === 'activity' && !expVal('ai_agent_analytics', 'isEnabled', false)) {
		return <NotFound />;
	}

	if (tab === 'users' && expVal('ai_agent_analytics', 'isEnabled', false)) {
		return <Redirection name={SITE_ANALYTICS.name} params={{ tab: 'activity' }} />;
	}

	return <SiteAnalyticsPageLoader />;
};

SiteAnalyticsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { tab },
}: RouteMatch):
	| false
	| {
			Screen: {
				pageState: {
					routeName: string;
					tab: string;
				};
			};
			MainLayout: {
				navView: string;
			};
	  } => {
	if (
		(tab === 'activity' && !expVal('ai_agent_analytics', 'isEnabled', false)) ||
		(tab === 'users' && expVal('ai_agent_analytics', 'isEnabled', false))
	) {
		return false;
	}

	return {
		Screen: {
			pageState: {
				routeName: name,
				tab: tab === 'activity' ? 'users' : tab,
			},
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
